import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {AuthService} from "@features/auth/auth.service";

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Con la pantalla bloqueada (también tras recargar) se vuelve a ella, no al login.
  router.navigate([authService.lockedSession() ? '/lock' : '/login']);
  return false;
};

/**
 * /lock solo con una sesión bloqueada (al bloquear se entra aún con los tokens, que se quitan al llegar); sin bloqueo,
 * a la app si hay sesión o al login si no.
 */
export const LockGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.lockedSession()) {
    return true;
  }
  return router.createUrlTree([authService.isAuthenticated() ? '/dashboard' : '/login']);
};
